import Store from 'store/store';

import { getCookie, setCookie } from 'utils/cookies';
import { waitForOneTrust } from 'utils/gdpr/oneTrust';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

async function loadExtraOneTrust() {
	const oneTrustData = Store.get().appData?.options?.oneTrustCookieConsent;
	const oneTrustScripts = oneTrustData?.scripts;

	// Only add the scripts if we were waiting for the age gate
	if (!oneTrustScripts || !oneTrustData.waitForAgeGate) {
		return;
	}

	try {
		// Ensure we show the banner by removing the closed banner cookie
		document.cookie = 'OptanonAlertBoxClosed=; expires=' + (new Date(0).toUTCString());
	} catch (e) {}

	await Promise.all(Object.values(oneTrustScripts).map(async script => {
		if (script.inlineContent) {
			let el = document.createElement('script');
			el.text = script.inlineContent;
			document.body.appendChild(el);
			return;
		}

		return new Promise((resolve, reject) => {
			let el = document.createElement('script');
			el.onload = resolve;
			el.onerror = reject;
			if (script.integrity) el.integrity = script.integrity;
			if (script.crossOrigin && script.crossOrigin !== 'none') el.crossOrigin = script.crossOrigin;
			if (script.dataDomainScript) el.setAttribute('data-domain-script', script.dataDomainScript);
			if (script.async) el.async = true;
			el.src = script.src;
			document.body.appendChild(el);
		});
	}));
}

async function loadExtraKetch() {
	const ketchData = Store.get().appData?.options?.ketchCookieConsent;
	// const ketchScripts = ketchData?.scripts;

	if (!ketchData?.scripts || !ketchData.waitForAgeGate) {
		return;
	}

	let el = document.createElement('script');
	el.text = ketchData.scripts;
	document.body.appendChild(el);
}

async function loadExtraCookieYes() {
	const cookieYes = Store.get().appData?.options?.cookieYesConsent;

	if (!cookieYes?.scripts || !cookieYes.waitForAgeGate) {
		return;
	}

	const fragment = document.createRange().createContextualFragment(cookieYes.scripts);
	document.body.appendChild(fragment);
}

Store.on('AGEGATE_OPEN', () => {
	const { deviceSize } = Store.get().client;
	if (deviceSize !== 'mobile') {
		const page = document.getElementById('bolt');
		disableBodyScroll(page);
	}
	Store.get().set({ ageGateOpen: true });
});

Store.on('AGEGATE_CLOSE', () => {
	const { deviceSize } = Store.get().client;
	if (deviceSize !== 'mobile') {
		const page = document.getElementById('bolt');
		enableBodyScroll(page);
	}
	Store.get().set({ ageGateOpen: false });
});

Store.on('AGEGATE_CONSENT', async (consentGiven) => {
	Store.get().client.set({ ofAge: !!consentGiven });
	// Note (BaliBalo): not sure why we are resetting cookie consent here
	Store.emit('ACCEPT_COOKIES', [], { doNotSetCookie: true });

	const ageGate = Store.get().appData?.options?.ageGate;
	if (ageGate?.redirect?.enabled && ageGate.redirect?.url && !consentGiven) {
		window.location.replace(ageGate.redirect?.url);
		return;
	}

	const cookieName = ageGate?.cookieName || 'pow-agegate';
	const cookieExpiry = +ageGate?.expiry || 365;
	if (!getCookie(cookieName)) {
		setCookie(cookieName, +consentGiven, cookieExpiry);
	}

	// TODO remove and move to new implementation
	if (!consentGiven) {
		Store.emit('CHECK_ACTIVE_PAGE_AGE_RESTRICTION');
		await waitForOneTrust();
		window.Optanon?.RejectAll();
	} else {
		await Promise.all([
			loadExtraOneTrust(),
			loadExtraKetch(),
			loadExtraCookieYes(),
			await waitForOneTrust(),
		]);
		// const domainData = window.Optanon?.GetDomainData();
		// if (domainData?.ForceConsent) {
		// 	window.Optanon?.AllowAll();
		// }
		// If we want to ensure the banner does not show:
		// window.Optanon?.Close();
		// Or to show the "manage consent" modal:
		// window.Optanon?.ToggleInfoDisplay();
	}
});